module.exports = __webpack_public_path__ + "public/SiteIcons/photoUpload.svg?e1a13332";